exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".colors-picker div:not(:last-child) {\n  margin-left: 8px;\n}\n.colors-picker input[type=radio] {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n}\n.colors-picker .color-container {\n  line-height: 16px;\n  cursor: pointer;\n  padding: 2px;\n}\n.colors-picker input[type=radio] + .color-container {\n  border: 2px solid transparent;\n}\n.colors-picker input[type=radio]:checked + .color-container {\n  border: 2px solid #facc2f;\n}", ""]);

// exports
